module.exports = __webpack_public_path__ + "static/media/iconDashboard.53e7cdd9.svg";